// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { Sport } from '../app/states/sport/sport.models';

import { IEnvironment, EnvironmentTier } from './environment.model';

export const environment: IEnvironment = {
    tier: EnvironmentTier.PRODUCTION,
    production: true,
    apis: {
        [Sport.HOCKEY]: 'https://app.sportlogiq.com',
        [Sport.SOCCER]: 'https://fcapp.sportlogiq.com',
        [Sport.FOOTBALL]: 'https://footballapp.sportlogiq.com'
    },
    apiVersion: 'api/v3',
    userApi: 'https://auth.sportlogiq.com',
    userApiVersion: 'api/v1',
    loginUrl: 'https://oneapp-staging.sportlogiq.com'
};
